import React, { Component } from "react";
import clsx from "clsx";

import PlaybookCategoryIcon from "./PlaybookCategoryIcon";

import "./playbook-identity.css";

class PlaybookIdentity extends Component {
	render() {
		const { agent, meta, chips, aside, action, isCompact, isDescriptionWrapped } = this.props;
		const version = agent.current_version;

		return (
			<div className={clsx("playbook-identity", isCompact && "playbook-identity--compact", isDescriptionWrapped && "playbook-identity--wrapped")}>
				<PlaybookCategoryIcon icon={agent.category ? agent.category.icon : null} />
				<div className="playbook-identity__main">
					<div className="playbook-identity__name">
						{version.name}
						<span className={clsx("tk-badge", agent.is_builtin ? "tk-badge--accent" : "tk-badge--neutral")}>
							{agent.is_builtin ? "Built-in" : "Custom"}
						</span>
					</div>
					<div className="playbook-identity__description">{version.description}</div>
					{chips && <div className="playbook-identity__chips tk-chips">{chips}</div>}
					{meta && <div className="playbook-identity__meta">{meta}</div>}
				</div>
				{aside && <div className="playbook-identity__aside">{aside}</div>}
				{action && <div className="playbook-identity__action">{action}</div>}
			</div>
		);
	}
}

export default PlaybookIdentity;
